export interface WarehouseNotificationConfig {
  id: number;
  location: string;
  subject: string;
  body: string;
  template_variables: string[];
}

export interface WarehouseGroupMember {
  membership_id: number;
  id: number;
  full_name: string;
  email: string;
}

export interface WarehouseDepartmentGroup {
  group_id: string;
  users: WarehouseGroupMember[];
  settings: GroupNotificationSettings;
  job_recipients: JobRecipient[];
}

export interface AssignableUser {
  id: number;
  full_name: string;
  email: string;
}

export const warehouseNotificationConfigUrl = (location: string): string =>
  `/warehouse/notification_configs/${location}`;

export const warehouseDepartmentGroupsUrl = '/warehouse/department_group_memberships';

export const warehouseAssignableUsersUrl = '/warehouse/assignable_users';

export type NotificationMode = 'additive' | 'supersede';

export type NotificationRoleKey = 'po_creator' | 'lead_tech' | 'coordinator' | 'salesperson';

export interface GroupNotificationSettings {
  mode: NotificationMode;
  roles: Record<NotificationRoleKey, boolean>;
}

export interface JobRecipient {
  id: number;
  job_id: string;
  job_desc: string | null;
  user: AssignableUser;
}

export interface OpenJob {
  job_id: string;
  description: string | null;
}

export interface PreviewRecipient {
  id: number;
  full_name: string;
  email: string;
  reasons: string[];
}

export interface RecipientPreview {
  po_number: string | null;
  department: string | null;
  groups: string[];
  job_id: string | null;
  error: string | null;
  recipients: PreviewRecipient[];
}

// Labels and ServMan sources mirror Warehouse::Receiving::NotificationRoles on the backend.
// Order matters: it is the order the checkboxes render in.
export const NOTIFICATION_ROLES: { key: NotificationRoleKey; label: string; field: string }[] = [
  { key: 'po_creator', label: 'PO Creator', field: 'pohdr.entered_by' },
  { key: 'lead_tech', label: 'Project Manager / Lead Tech', field: 'job.U_LEAD' },
  { key: 'coordinator', label: 'Project Coordinator', field: 'job.U_PRJCOORD' },
  { key: 'salesperson', label: 'Project Salesperson', field: 'job.U_BSALE1' },
];

export const warehouseGroupSettingsUrl = (groupId: string): string =>
  `/warehouse/group_notification_settings/${encodeURIComponent(groupId)}`;

export const warehouseJobRecipientsUrl = '/warehouse/group_job_recipients';

export const warehouseOpenJobsUrl = '/warehouse/open_jobs';

export const warehouseRecipientPreviewUrl = '/warehouse/recipient_preview';
